import useProductSummary from "@lululemon/ecom-pdp/src/hooks/useProductSummary";
import { useABFlag } from "@lululemon/mwa-ab-testing/esm";

export const useIsPopularCategoriesEnabled = () =>
  useABFlag("PDPShopPopularCategories", false);

//This will be replaced with the actual data set from MT
export const categoriesDataSet = [
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Leggings",
  },
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Shorts",
  },
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Hoodies & Sweaters",
  },
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Coats & Jackets",
  },
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Sports Bras",
  },
  {
    url: "https://shop.lululemon.com",
    imageUrl:
      "https://images.lululemon.com/is/image/lululemon/NA_Aug20_AugWk5_SeaWheeze_EventPage_1_2_lg_Masonry_D_Right",
    name: "Tank Tops",
  },
];

export const useCategories = () => {
  const { gender, allAncestorsDisplayName } = useProductSummary();
  const genderText = gender?.length ? gender?.[0]?.toLowerCase() : "";
  const title = allAncestorsDisplayName?.includes("Accessories")
    ? "Shop popular accessories"
    : `Shop popular ${genderText}'s categories`;

  return {
    title,
    dataSet: categoriesDataSet,
  };
};
